export const ConsumerNameFormStyles = {
  title:
    'text-center mt-8 text-blue700 text-16px font-bold sm:text-20px sm:font-normal sm:mt-12',
  formWrapper: 'flex flex-col items-center w-full',
  formContainer: 'flex flex-col w-full gap-x-2.5 items-center justify-center 1xl:flex-row',
  inputField: 'flex justify-center w-full sm:mr-0',
  button: 'text-xl sm:text-2xl mt-3'
}
